/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["मध्यरात", "मध्यान्ह", "बिहान", "अपरान्ह", "साँझ", "बेलुकी", "रात"], u, u], u, ["00:00", "12:00", ["04:00", "12:00"], ["12:00", "16:00"], ["16:00", "19:00"], ["19:00", "22:00"], ["22:00", "04:00"]]];
